import React from 'react';
import TimeTrackingCalendar from './TimeTrackingCalendar';

const TimeTracking = () => {
  return <TimeTrackingCalendar />;
};

export default TimeTracking;